import { render, staticRenderFns } from "./cosmeticsList.vue?vue&type=template&id=14ffe286&scoped=true&"
import script from "./cosmeticsList.vue?vue&type=script&lang=js&"
export * from "./cosmeticsList.vue?vue&type=script&lang=js&"
import style0 from "./cosmeticsList.vue?vue&type=style&index=0&id=14ffe286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ffe286",
  null
  
)

export default component.exports